module.exports = __webpack_public_path__ + "img/shutterstock_379530769@2x.9a9e3910.png";